// =================================================
// TABLE OF CONTENTS: Functions
// =================================================

// (0.0) General Variable and Functions
// ------------------------------------------- * * *
// (0.1) safari detection
// (0.2) Commonly used IDs
// (0.3) Hamburger

// (1.0) Desktop Functionality
// ------------------------------------------- * * *
// (1.1) load desktop nav click functions
// (1.2) Listeners and Keystroke Events
// (1.3)  Browser window width

// (2.0) Mobile Functionality
// ------------------------------------------- * * *
// (2.1) load desktop nav functionality
// (2.2) Listeners and Keystroke Events

// (3.0) Select Menu Funtionailty
// ------------------------------------------- * * *
// (3.1) Pick Menu
// (3.2) Window Resizing


const $ = jQuery.noConflict();


$(document).ready(function () {


  /*==================================================================
  // (0.0) General Variable and Functions
  // ------------------------------------------- * * *
  // (0.1) safari detection
  // (0.2) Commonly used IDs
  // (0.3) Hamburger
	================================================================= */

  // (0.1) Detect Safari, https://gist.github.com/darryl-snow/3822361
  eval(function (p, a, c, k, e){e=function (c){return (c<a?'':e(c/a))+String.fromCharCode(c%a+161);};while (c--){if (k[c]){p=p.replace(new RegExp(e(c), 'g'), k[c]);}} return p;}('Ö ¡(){® Ø={\'¥\':¡(){¢ £.¥},\'©\':{\'±\':¡(){¢ £.©.±},\'¯\':¡(){¢ £.©.¯}},\'¬\':¡(){¢ £.¬},\'¶\':¡(){¢ £.¶},\'º\':¡(){¢ £.º},\'Á\':¡(){¢ £.Á},\'À\':¡(){¢ £.À},\'½\':¡(){¢ £.½},\'¾\':¡(){¢ £.¾},\'¼\':¡(){¢ £.¼},\'·\':¡(){¢ £.·},\'Â\':¡(){¢ £.Â},\'³\':¡(){¢ £.³},\'Ä\':¡(){¢ £.Ä},\'Ã\':¡(){¢ £.Ã},\'Å\':¡(){¢ £.Å},\'¸\':¡(){¢ £.¸}};$.¥=Ø;® £={\'¥\':\'¿\',\'©\':{\'±\':²,\'¯\':\'¿\'},\'¬\':\'¿\',\'¶\':§,\'º\':§,\'Á\':§,\'À\':§,\'½\':§,\'¾\':§,\'¼\':§,\'·\':§,\'Â\':§,\'³\':§,\'Ä\':§,\'Ã\':§,\'Å\':§,\'¸\':§};Î(® i=0,«=».ì,°=».í,¦=[{\'¤\':\'Ý\',\'¥\':¡(){¢/Ù/.¨(°)}},{\'¤\':\'Ú\',\'¥\':¡(){¢ Û.³!=²}},{\'¤\':\'È\',\'¥\':¡(){¢/È/.¨(°)}},{\'¤\':\'Ü\',\'¥\':¡(){¢/Þ/.¨(°)}},{\'ª\':\'¶\',\'¤\':\'ß Ñ\',\'¥\':¡(){¢/à á â/.¨(«)},\'©\':¡(){¢ «.¹(/ã(\\d+(?:\\.\\d+)+)/)}},{\'¤\':\'Ì\',\'¥\':¡(){¢/Ì/.¨(«)}},{\'¤\':\'Í\',\'¥\':¡(){¢/Í/.¨(°)}},{\'¤\':\'Ï\',\'¥\':¡(){¢/Ï/.¨(«)}},{\'¤\':\'Ð\',\'¥\':¡(){¢/Ð/.¨(«)}},{\'ª\':\'·\',\'¤\':\'å Ñ\',\'¥\':¡(){¢/Ò/.¨(«)},\'©\':¡(){¢ «.¹(/Ò (\\d+(?:\\.\\d+)+(?:b\\d*)?)/)}},{\'¤\':\'Ó\',\'¥\':¡(){¢/æ|Ó/.¨(«)},\'©\':¡(){¢ «.¹(/è:(\\d+(?:\\.\\d+)+)/)}}];i<¦.Ë;i++){µ(¦[i].¥()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¥=¦[i].¤;® ­;µ(¦[i].©!=²&&(­=¦[i].©())){£.©.¯=­[1];£.©.±=Ê(­[1])}ê{® Ç=Ö ë(¦[i].¤+\'(?:\\\\s|\\\\/)(\\\\d+(?:\\\\.\\\\d+)+(?:(?:a|b)\\\\d*)?)\');­=«.¹(Ç);µ(­!=²){£.©.¯=­[1];£.©.±=Ê(­[1])}}×}};Î(® i=0,´=».ä,¦=[{\'ª\':\'¸\',\'¤\':\'ç\',\'¬\':¡(){¢/é/.¨(´)}},{\'¤\':\'Ô\',\'¬\':¡(){¢/Ô/.¨(´)}},{\'¤\':\'Æ\',\'¬\':¡(){¢/Æ/.¨(´)}}];i<¦.Ë;i++){µ(¦[i].¬()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¬=¦[i].¤;×}}}();', 77, 77, 'function|return|Private|name|browser|data|false|test|version|identifier|ua|OS|result|var|string|ve|number|undefined|opera|pl|if|aol|msie|win|match|camino|navigator|mozilla|icab|konqueror|Unknown|flock|firefox|netscape|linux|safari|mac|Linux|re|iCab|true|parseFloat|length|Flock|Camino|for|Firefox|Netscape|Explorer|MSIE|Mozilla|Mac|toLowerCase|new|break|Public|Apple|Opera|window|Konqueror|Safari|KDE|AOL|America|Online|Browser|rev|platform|Internet|Gecko|Windows|rv|Win|else|RegExp|userAgent|vendor'.split('|')));

  let userbrowser = $.browser.browser(); // Detected user browser

  if (userbrowser === 'Safari') {
    $('html').addClass('safari');
  } else if (userbrowser === 'Firefox') {
    $('html').addClass('firefox');
  }
  //End Detect Safari

  $('input[name="search"]').value = '';

  // (0.2) Commonly used IDs
  let hamButton = document.getElementById('hamburger'),
    //  mainNavWrap = document.getElementById('ucla-menu-wrap');
    mainNav = document.getElementById('main-nav');
  header = document.getElementById('header');
  mainContent = document.getElementById('main-content');
  searchButton = document.getElementById('search-button'),
  searchMenu = document.getElementById('search-menu'),
  searchInputMobile = document.getElementById('gsc-i-id1'),
  searchInputDesktop = document.getElementById('gsc-i-id2'),
  $body = $('body');


  // (0.3) The hamClick function toggles the opening and closing of the primary navigation on mobile devices when the hamburger is clicked.
  hamButton.onclick = function hamClick () {
    hamButton.classList.toggle('is-active');
    //  mainNavWrap.classList.toggle('is-active');
    mainNav.classList.toggle('is-active');
    header.classList.toggle('is-active');
    mainContent.classList.toggle('active-menu');
    $('.primary-nav__second-level-nav').removeClass('is-active');


    if (hamButton.classList.contains('is-active')) {
      hamButton.setAttribute('aria-expanded', 'true');
      $('.primary-nav__top-level a, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '0');
      $(hamButton).attr('aria-label', 'Close mobile menu');
    } else {
      hamButton.setAttribute('aria-expanded', 'false');
      $('.primary-nav__top-level a, .primary-nav__go-back, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '-1');
      $(hamButton).attr('aria-label', 'Open mobile menu');
      $('.primary-nav__go-back').removeClass('is-active');
      $('.primary-nav__top-level').css('overflow-y', 'scroll');
    }
  };

  /*==================================================================
  // (1.0) Desktop Functionality
  // ------------------------------------------- * * *
  // (1.1) load desktop nav click functions
  // (1.2) Listeners and Keystroke Events
  // (1.3)  Browser window width
	================================================================= */
  function desktopMenu ($) {
    // (1.1) load desktop nav click function
    let secondLevelNav = document.getElementsByClassName('primary-nav__second-level-nav');

    // If a menu item is in focus, mousing over another menu item will result in closing the focused menu.
    for (let i = 0; i < document.getElementsByClassName('primary-nav__top-level-link').length; i++) {
      document.getElementsByClassName('primary-nav__top-level-link')[i].addEventListener('mouseenter', function (event) {
        if ($('.primary-nav__top-level-link.link-desktop').hasClass('open')) {
          event.preventDefault();
          $('.primary-nav__top-level-link').removeClass('open');
          $('.primary-nav__second-level-nav').css('display', '');

        } else if ($('.primary-nav__top-level-link.link-desktop').is(':focus')) {
          event.preventDefault();
          $('.primary-nav__top-level-link.link-desktop').blur();
        }
      });
      document.getElementsByClassName('primary-nav__top-level-li')[i].addEventListener('mouseover', function (event) {
        event.currentTarget.querySelector('a').setAttribute('aria-expanded', 'true');
      });
      document.getElementsByClassName('primary-nav__top-level-li')[i].addEventListener('mouseout', function (event) {
        event.currentTarget.querySelector('a').setAttribute('aria-expanded', 'false');
      });
    }


    // If a menu item is focused and the mouse clicks anywhere else on the page the menu will close.
    $(document).click(function (){
      if ($('.primary-nav__top-level-link.link-desktop').hasClass('open')) {
        $('.primary-nav__top-level-link.link-desktop').removeClass('open');
        $(this).find('.primary-nav__second-level-nav').css('display', '');

      }
    });

    $('.primary-nav__top-level a, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '0');

    // Add the width off the window to the submenu
    desktopSubmenuResize($);

    // This function controls what happens when you click the desktop menu search button
    searchButton.onclick = function () {
      $('.desktop-searches').toggleClass('is-active');
      searchMenu.classList.toggle('is-active');

      if ($('.desktop-searches').hasClass('is-active')) {
        $('input#gsc-i-id2').focus();
        $(searchButton).attr('aria-label', 'Close Search menu');
        $(searchButton).attr('aria-expanded', 'true');
        $('.search-button_image').attr('src', 'img/close--blue.svg');
        searchButton.classList.add('is-active');

        for (let i = 0; i < secondLevelNav.length; i += 1) {
          secondLevelNav[i].style.display = 'none';
          $('.primary-nav__second-level-nav.desktop-searches').css('display', '');
        }

      } else {
        $(searchButton).attr('aria-label', 'Open Search menu');
        $(searchButton).attr('aria-expanded', 'false');
        $('.search-button_image').attr('src', 'img/search--blue.svg');
        searchButton.classList.remove('is-active');

        for (let i = 0; i < secondLevelNav.length; i += 1){
				  secondLevelNav[i].style.display = '';
        }

      }
    };

    // (1.2) Listeners and Keystroke Events
    // These keystroke events control where a keyboard user is focused when using the tab key.
    document.onkeydown = function (evt) {

      let element = document.activeElement, // The active elemenet in focus
 						searchValue = $('input#gsc-i-id2').val(); // search input box
      evt = evt || window.event; // when an event keydown event happens and the browser window is active.
      /* =======
      - Screen readers and keyboards read html from top to bottom. When pressing tab all browser will jump to the next link in the top to bottom order.
      - All added events change what the browser does by default. Add events only when necessary to fit the design.
      - When adding an keybinding event, add it in the order that it is found in the html. (i.e. - Skip nav is at the top of the html page so goes first in the order.)


      This is the basic keydown function that creates specific events to help guide keyboard users.
      Find your keydown number - https://keycode.info/

      // If object is selectable and is in focus
      if ($('.class-name').is(':focus')) {

        // if the tab key is pressed while the object is focused
        if (evts.keyCode === 9) {

          // Preform an action when the specific key is pressed
          event.preventDefault(); // May require override of default event
          $(element).prev('li').children('a').focus();
        }

      // Repeat again for element further down the html chain.
      } else if ($('.class-name').is(':focus')){

        // Repeat speceific key event action

      }

      ======= */
      if ($('.skip-nav__desktop-nav').is(':focus')) {

        if (evt.key === 'Enter') { // Return Key
          setTimeout(function () {
            $('#about-menu').focus();
          }, 100);

        }

      } else	if ($('.skip-nav__desktop-search').is(':focus')) {

        if (evt.key === 'Enter') { // Return Key

          $('.desktop-searches').toggleClass('is-active');
          searchMenu.classList.toggle('is-active');


          if ($('.desktop-searches').hasClass('is-active')) {
            setTimeout(function () {
              $('input#gsc-i-id2').focus();
            }, 100);


          }
        }

      } else if ($('.primary-nav__top-level-link').is(':focus')) {

        if (evt.key === 'ArrowDown') { // Tab
          evt.preventDefault();
          $(element).next('.primary-nav__second-level-nav').css('display', 'block');
          //$(element).parent().next().find('.primary-nav__second-level-link').focus();
          $(element).addClass('open');
          $(element).attr('aria-expanded', 'true');

        } else if (evt.key === 'ArrowRight') { // Right Arrow
          $(element).next('.primary-nav__second-level-nav').css('display', '');
          $(element).parent().next().find('.primary-nav__top-level-link').focus();
          $(element).removeClass('open');

        } else if (evt.key === 'ArrowLeft') { // Left Arrow
          $(element).parent().prev().find('.primary-nav__top-level-link').focus();
          $(element).removeClass('open');

        }

      } else if ($('.primary-nav__second-level-nav > .primary-nav__stack-holder > .primary-nav__stack-holder-wrap > .primary-nav__menu-stack:first-child > li:nth-of-type(2) > a').is(':focus')) {
        if ((evt.key === 'Tab' && evt.shiftKey) || evt.key === 'Escape') {
          $(element).parent().parent().parent().parent().parent().css('display', '');
          $(element).parent().parent().parent().parent().parent().prev().removeClass('open');
          $(element).parent().parent().parent().parent().parent().prev().attr('aria-expanded', 'false');
        }
      } else if ($('.primary-nav__second-level-nav > .primary-nav__stack-holder > .primary-nav__stack-holder-wrap > .primary-nav__menu-stack:last-child > li:last-child > a').is(':focus')) {

        if (evt.key === 'Tab' || evt.key === 'Escape') { // Tab Key
          $(element).parent().parent().parent().parent().parent().css('display', '');
          $(element).parent().parent().parent().parent().parent().prev().removeClass('open');
          $(element).parent().parent().parent().parent().parent().prev().attr('aria-expanded', 'false');
        }

      } else if ($('.primary-nav__second-level-nav > .primary-nav__stack-holder > .primary-nav__stack-holder-wrap > .primary-nav__menu-stack > li > a').is(':focus')) {
        if (evt.key === 'Escape') { // Tab Key
          $(element).parent().parent().parent().parent().parent().css('display', '');
          $(element).parent().parent().parent().parent().parent().prev().removeClass('open');
          $(element).parent().parent().parent().parent().parent().prev().attr('aria-expanded', 'false');
          $(element).parent().parent().parent().parent().parent().prev().focus();
        }
      } else if ($('input#gsc-i-id2').is(':focus') && searchValue === '') {

        if (evt.key === 'Tab') { // Tab Key
          $('.desktop-searches').removeClass('is-active');
          searchMenu.classList.remove('is-active');
        }

      } else if ($('a.gsst_a').is(':focus')) {
        if (evt.key === 'Tab') { // Tab Key
          $('.desktop-searches').removeClass('is-active');
          searchMenu.classList.remove('is-active');
        }

      }
    };

  }

  /* (1.3) Browser window width
  This function detects the width of the browser window on load and if changed. It applies the found width to the primary navigation submenu as inline html. This prevents window sidescrolling and allows us to extend the width of the submenu past its parent width.
	================================================================= */
  function desktopSubmenuResize ($) {
    let w = $(window).width(),
      offset = $('.primary-nav__top-level').offset(),
      negOffset = offset.left * -1;

    $('.primary-nav__top-level a, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '0');

    //Add the width off the window to the submenu
    $('.primary-nav__second-level-nav').css('width', w);

    //Offset the menu to the left of the window.
    $('.primary-nav__second-level-nav').css({'left': negOffset});
  }

  /*==================================================================
	2.0 Mobile Functionality
	================================================================= */
  function mobileMenu ($) {
    // (2.1) load mobile nav functionality

    let desktop = 1024;

    // Remove and widths that the desktop sets.
    $('.primary-nav__second-level-nav').removeAttr('style');
    // Menu is closed onload so the links are not tabable until the menu is open
    setTimeout(function () {
      $('.primary-nav__top-level a, .primary-nav__go-back, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '-1');
    }, 10);

    // Click the top level link
    for (let i = 0; i < document.getElementsByClassName('primary-nav__top-level-link').length; i++) {
      document.getElementsByClassName('primary-nav__top-level-link')[i].addEventListener('click', function (event) {
        if (window.innerWidth < desktop) {
          event.preventDefault();
          $('.primary-nav__top-level').scrollTop(0);
          $('.primary-nav__second-level-nav').scrollTop(0);
          $(this).attr('aria-expanded', true);
          $(this).next('.primary-nav__second-level-nav').addClass('is-active');
          $(this).next('.primary-nav__second-level-nav').find('.primary-nav__go-back').addClass('is-active');
          $('.primary-nav__top-level').css('overflow-y', 'hidden');

        }
      });
    }

    // Click the go back menu link
    for (let i = 0; i < document.getElementsByClassName('primary-nav__go-back').length; i++) {
      document.getElementsByClassName('primary-nav__go-back')[i].addEventListener('click', function (event) {
        if (window.innerWidth < desktop) {
          event.preventDefault();
          $(this).parent('.primary-nav__second-level-nav').removeClass('is-active');
          $(this).removeClass('is-active');
          $(this).parent().siblings('.primary-nav__top-level-link').attr('aria-expanded', 'false');
          $('.primary-nav__top-level').css('overflow-y', 'scroll');
        }
      });
    }

    // (2.2) Listeners and Keystroke Events
    // - Screen readers and keyboards read html from top to bottom. When pressing tab all browser will jump to the next link in the top to bottom order.
    // - All added events change what the browser does by default. Add events only when necessary to fit the design.
    // - When adding an keybinding event, add it in the order that it is found in the html. (i.e. - Skip nav is at the top of the html page so goes first in the order.)
    // - See section 1.2 for key function example.
    document.onkeydown = function (evt) {

      let element = document.activeElement, // The active elemenet in focus
        //searchValue = $('input#gsc-i-id1').val();
        evts = evt || window.event; // when an event happen in the window

      if ($('.skip-nav__mobile-nav').is(':focus')) {
        if (evts.key === 'Enter') { // Return Key

          if ($('#hamburger').hasClass('is-active')) {
            event.preventDefault();
            $('#about-menu').focus();
          } else {
            $('#hamburger').trigger('click');
            $('#about-menu').focus();
          }

        }

      } else	if ($('.skip-nav__mobile-search').is(':focus')) {

        if (evts.key === 'Enter') { // Return Key

          if ($('#hamburger').hasClass('is-active')) {
            event.preventDefault();
            $('input#gsc-i-id1').focus();
          } else {
            $('#hamburger').trigger('click');
            $('input#gsc-i-id1').focus();
          }

        }

      } else if ($('#about-menu').is(':focus')) {

        if (evts.key === 'Enter') { // Return Key
          $(element).children('.primary-nav__top-level-link').attr('aria-expanded', 'true');
          $(element).next('ul').find('.primary-nav__go-back').attr('tabindex', '0');
          setTimeout(function () {
            $(element).next('ul').find('.primary-nav__go-back').focus();
          }, 100);

        } else if (evts.key === 'Shift') {
          event.preventDefault();
          $('input#gsc-i-id1').focus();

        } else if (evts.keyCode === 9) { // Tab Key

          event.preventDefault();
          $(element).parent().next('.primary-nav__top-level-li').children('a').focus();

        }

        // direct to mobile only links
      } else if ($('#campus-life-menu').is(':focus')) {

        // Hit enter to open the second level flyout
        if (evts.key === 'Enter') { // Return Key
          $(element).attr('aria-expanded', 'true');
          $(element).next('ul').find('.primary-nav__go-back').attr('tabindex', '0');
          setTimeout(function () {
            $(element).next('ul').find('.primary-nav__go-back').focus();
          }, 100);

        } else if (evt.key === 'Tab' && event.key === 'Shift') { // Tab and Shift Keys

          event.preventDefault();
          $(element).parent().prev('.primary-nav__top-level-li').children('a').focus();

        } else if (evt.key === 'Tab') { // Tab Key
          event.preventDefault();
          $(element).parent().next().next('.primary-nav__top-level-mobile-li').children('a').focus();
        }

        // direct to Give Button
      } else if ($('#public-transit-menu').is(':focus')) {

        // if you hit shift+tab it will go back up a menu item
        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys
          event.preventDefault();
          $(element).parent().prev('.primary-nav__top-level-mobile-li').children('a').focus();

        } else if (evts.key === 'Tab') { // Tab Key
          event.preventDefault();
          $(element).parent().next().find('a').focus();
        }

      } else if ($('.primary-nav__top-level-link').is(':focus')) {

        //if you hit enter it will open the second level flyout
        if (evts.key === 'Enter') { // Return Key

          $(element).attr('aria-expanded', 'true');
          $(element).next('ul').find('.primary-nav__go-back').attr('tabindex', '0');

          setTimeout(function () {
            $(element).next('ul').find('.primary-nav__go-back').focus();
          }, 100);

          $('.primary-nav__top-level').css('overflow-y', 'hidden');

          // if you hit tab instead of enter it move to the next list item and skips the flyout
        } else if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          evts.preventDefault();
          $(element).parent().prev('.primary-nav__top-level-li').children('a').focus();

        } else if (evts.key === 'Tab') { // Tab Key

          evts.preventDefault();
          $(element).parent().next('.primary-nav__top-level-li').children('a').focus();

        }

      } else if ($('.primary-nav__menu-stack.last-mobile > li:last-child > a').is(':focus')) {


        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          evts.preventDefault();
          $(element).parent().prev('li').children('a').focus();

        } else if (evts.key === 'Tab') { // Tab Key

          evts.preventDefault();
          $(window).scrollTop(0);
          $(element).parent().parent().parent().parent().siblings('.primary-nav__go-back').focus();

        }

      } else if ($('.primary-nav__second-level-nav > li > a').is(':focus')) {

        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          $(element).prev('li').children('a').focus();

        }

      } else if ($('#directory-menu').is(':focus')) {

        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          event.preventDefault();
          $(element).parent().prev().prev('.primary-nav__top-level-li').children('a').focus();

        } else if (evts.key === 'Tab') {

          $(element).parent().next('.primary-nav__top-level-li').children('a').focus();

        }

      } else if ($('#give-btn').is(':focus')) {

        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          evts.preventDefault();
          $(element).parent().prev('.primary-nav__top-level-mobile-li').children('a').focus();

        } else if (evts.key === 'Tab') { // Tab Key

          evts.preventDefault();

          setTimeout(function () {
            hamButton.classList.toggle('is-active');
					  mainNav.classList.toggle('is-active');
            //mainNavWrap.classList.toggle('is-active');
            header.classList.toggle('is-active');
            mainContent.classList.toggle('active-menu');
            $('.primary-nav__second-level-nav').removeClass('is-active');
            $body.removeClass('no-scroll');
            $('main#main-content a').first().focus();

				    if (hamButton.classList.contains('is-active')) {

				      hamButton.setAttribute('aria-expanded', 'true');
              $('.primary-nav__top-level a, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '0');
              $(hamButton).attr('aria-label', 'Close mobile menu');

				    } else {

				      hamButton.setAttribute('aria-expanded', 'false');
              $('.primary-nav__top-level a, .primary-nav__go-back, .gsc-search-button.gsc-search-button-v2, input#gsc-i-id1').attr('tabindex', '-1');
              $(hamButton).attr('aria-label', 'Open mobile menu');

				    }


          }, 1);
        }

      } else if ($('.primary-nav__top-level-mobile-link').is(':focus')) {

        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          evts.preventDefault();
          $(element).parent().prev('.primary-nav__top-level-mobile-li').children('a').focus();

        } else if (evts.key === 'Tab') {

          evts.preventDefault();
          $(element).parent().next('.primary-nav__top-level-mobile-li').children('a').focus();

        }

      }	else if ($('.primary-nav__go-back').is(':focus')) {

        if (evts.key === 'Tab' && evts.shiftKey) { // Tab and Shift Keys

          evts.preventDefault();


        } else if (evts.key === 'Enter') { // Return Key
          $(element).parent().siblings('.primary-nav__top-level-link').attr('aria-expanded', false);
          $('.primary-nav__go-back').parent('.primary-nav__second-level-nav').removeClass('is-active');

          setTimeout(function () {
            $(element).parent().prev().focus();
          }, 100);

          $('.primary-nav__top-level').css('overflow-y', 'scroll');

        }
      }	else {
        // do nothing
      }

    };

    /* Disable Mobile scroll when menu is open CSS for no-scroll in stylesheet */
    $('#hamburger').on('click', scrollDisable);

    function scrollDisable () {
      if (hamButton.classList.contains('is-active')) {
        $body.addClass('no-scroll');
      } else {
        $body.removeClass('no-scroll');
      }
    }

  }

  /*==================================================================
	3.0 Select Menu Funtionailty
  Sections 1 defines the difference in functionality between desktop and mobile devices. Section 2 determines which functionality to load based on the users browser window size.
  // (3.1) Define Menus
  // (3.2) Select a menu based on Window size.
	================================================================= */

  // (3.1) Pick Menu - Defines the menu functionality and how they work on desktop vs. mobile devices.
  function pickMenu ($) {

    let desktop = 1024;

    setTimeout(function () {
      $('input#gsc-i-id1, .gsc-search-button.gsc-search-button-v2').attr('tabindex', '-1');
      $('.primary-nav__go-back').removeClass('is-active');
    }, 500);

    if (window.innerWidth >= desktop) {
      // If the window is greater than or equal to 1024px reset these classes to use the desktop functionailty.
      desktopMenu($);
      $('.primary-nav__top-level-link').addClass('link-desktop');
      $('header, ul, nav, #hamburger, #header-wrap').removeClass('is-active');
      $('#main-content').removeClass('active-menu');
      $('.primary-nav__top-level').css('overflow-y', 'visible');
      $body.removeClass('no-scroll');
      $(searchButton).attr('aria-label', 'Open Search menu');
      $(searchButton).attr('aria-expanded', 'false');
      $('.desktop-searches').removeClass('is-active');

    } else if (window.innerWidth < desktop){
      // If the window is smaller than 1024px reset these classes to use the desktop functionailty.
      mobileMenu($);
      $('.primary-nav__top-level-link').removeClass('link-desktop');
      $('header, ul, nav, #hamburger, #header-wrap').removeClass('is-active');
      $('#main-content').removeClass('active-menu');
      $('.primary-nav__top-level').css('overflow-y', 'scroll');
      $body.removeClass('no-scroll');
      $(searchButton).attr('aria-label', 'Open Search menu');
      $(searchButton).attr('aria-expanded', 'false');
      $('#search-menu').removeClass('is-active');
    }

  }

  pickMenu($);

  // (3.2)	Select which functionailty to load when the browser window is resized.
  let isSmall = false;
  $(window).resize(function () {

    // This runs the pickMenu function only when the window is resized above or equal to 1024px.
    if ((window.innerWidth < 1024 && !isSmall) || (window.innerWidth >= 1024 && isSmall)) {

      isSmall = !isSmall;

      // Run the pickMenu function from (3.1). Without the timing delay bugs appear in the nav.
      setTimeout(function () {
        pickMenu($);
      }, 10);
    }

    // This adds the browser window width to the primary navigation submenu for desktop only.
    if (window.innerWidth >= 1024) {
      // Run the desktopSubmenuResize function from (1.3)
      desktopSubmenuResize($);
    }

  });

});
